/**
 * Join key for extension UUIDs. mango-api keeps the legacy mixed-case values
 * while hotels-service stores them lowercased, so every join across the two
 * must ignore case.
 */
export const extensionUuidKey = (uuid: string | null | undefined): string =>
  (uuid ?? '').toLowerCase()
